import M365EntraIDSection from "components/settings/permissions/m365-entra-id/m365-entra-id-section/m365-entra-id-section";

export default function M365EntraIDIndex() {

    return (
        <M365EntraIDSection />
    );
}